module.exports = __webpack_public_path__ + "img/icon40.79cc23f1.png";